import { useTranslation } from 'react-i18next';
// @mui
import { Box, Stack, Typography } from '@mui/material';
// assets
import { UploadIllustration } from '../../assets';

// ----------------------------------------------------------------------

export default function BlockContent() {
  const { t } = useTranslation('Components', { keyPrefix: 'BlockContent' });

  return (
    <Stack
      spacing={2}
      alignItems="center"
      justifyContent="center"
      direction={{ xs: 'column', md: 'row' }}
      sx={{ width: 1, textAlign: { xs: 'center', md: 'left' } }}
    >
      <UploadIllustration sx={{ width: 220 }} />

      <Box sx={{ p: 3 }}>
        <Typography gutterBottom variant="h5">
          {t('Drop_Or_Select_File')}
        </Typography>

        <Typography variant="body2" sx={{ color: 'text.secondary' }}>
          {t('Drop_File_Or_Click')}&nbsp;
          <Typography variant="body2" component="span" sx={{ color: 'primary.main', textDecoration: 'underline' }}>
            {t('Browse')}
          </Typography>
          &nbsp;{t('Thorough_Your_Machine')}
        </Typography>
      </Box>
    </Stack>
  );
}
